import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/material-library',
    name: 'MaterialLibrary',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/material-library/model-library/list',
    meta: {
      title: '素材库',
    },
    children: [
      {
        path: 'designated-model-library/list',
        name: 'MaterialLibraryDesignatedModelLibraryList',
        component: () => import('@/modules/material-library/designated-model-library/views/list/index.vue'),
        meta: {
          title: '指定模型库',
          auth: true,
        },
      },
      {
        path: 'scene-library-manage/list',
        name: 'SystemManageSceneLibraryManage',
        component: () => import('./scene-library-manage/views/list/index.vue'),
        meta: {
          title: '场景库管理',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/create',
        name: 'SystemManageSceneLibraryManageCreate',
        component: () => import('./scene-library-manage/views/create/index.vue'),
        meta: {
          title: '新建场景库',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/detail/:id',
        name: 'SystemManageSceneLibraryManageDetail',
        component: () => import('./scene-library-manage/views/detail/index.vue'),
        meta: {
          title: '场景库详情',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/edit/:id',
        name: 'SystemManageSceneLibraryManageEdit',
        component: () => import('./scene-library-manage/views/detail/index.vue'),
        meta: {
          title: '编辑场景库',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'model-library-manage/list',
        name: 'SystemManageModelLibraryManage',
        component: () => import('./model-library-manage/views/list/index.vue'),
        meta: {
          title: '模特库管理',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/create',
        name: 'SystemManageModelLibraryManageCreate',
        component: () => import('./model-library-manage/views/create/index.vue'),
        meta: {
          title: '新建模特库',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/detail/:id',
        name: 'SystemManageModelLibraryManageDetail',
        component: () => import('./model-library-manage/views/detail/index.vue'),
        meta: {
          title: '模特库详情',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/edit/:id',
        name: 'SystemManageModelLibraryManageEdit',
        component: () => import('./model-library-manage/views/create/index.vue'),
        meta: {
          title: '编辑模特库',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'style-manage/list',
        name: 'SystemManageStyleManage',
        component: () => import('./style-manage/views/list/index.vue'),
        meta: {
          title: '风格管理',
          auth: true,
        },
      },
      {
        path: 'posture-manage/list',
        name: 'SystemManagePostureManageList',
        component: () => import('./posture-manage/views/list/index.vue'),
        meta: {
          title: '姿势管理',
          auth: true,
        },
      },
      {
        path: 'posture-manage/detail/:id',
        name: 'SystemManagePostureManageDetail',
        component: () => import('./posture-manage/views/detail/index.vue'),
        meta: {
          title: '姿势管理',
          auth: true,
          activeMenu: 'SystemManagePostureManageList'
        },
      },
    ],
  },
] as IRouteConfig[];
